import { render, staticRenderFns } from "./StepperHeader.vue?vue&type=template&id=fd985210&scoped=true"
import script from "./StepperHeader.vue?vue&type=script&lang=ts"
export * from "./StepperHeader.vue?vue&type=script&lang=ts"
import style0 from "./StepperHeader.vue?vue&type=style&index=0&id=fd985210&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd985210",
  null
  
)

export default component.exports